import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />

        <AboutSection />

        <ContactSection />

        <CardsSection />

        <AppSection />

        <CommentsSection />

        <RankingSection />

        <MediaSection />

        <FAQSection />

        <CarouselSection />

        <IndexSection />

        <FeaturesSection />

        <UpdatesSection />

        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}